module.exports = __webpack_public_path__ + "img/filter-icon.3205db5e.svg";